import { BigNumber } from '@xylabs/bignumber'
import { EthAddress } from '@xylabs/sdk-js'

import { XyoWorldBase } from '../../../../Base'
import { parseBigNumberOptional } from '../../../../parseBigNumber'
import { Quadkey } from '../../../../Quadkey'
import { DynamicAuctionJsonObject } from './JsonObject'

export class DynamicData extends XyoWorldBase<DynamicAuctionJsonObject> {
  bidder?: EthAddress

  canMintForReward?: boolean

  currentBid?: BigNumber

  dutchAuctionActive?: boolean

  dutchAuctionPrice?: BigNumber

  minimumBid?: BigNumber

  mintNowPrice?: BigNumber

  quadkey: Quadkey

  constructor(quadkey: Quadkey, jsonObject?: DynamicAuctionJsonObject) {
    super()
    this.quadkey = quadkey
    if (jsonObject) {
      this.loadJsonObject(jsonObject)
    }
  }

  public hasBid() {
    return this.currentBid !== undefined
  }

  public loadJsonObject(jsonObject?: DynamicAuctionJsonObject) {
    if (jsonObject) {
      this.bidder = EthAddress.parse(jsonObject.bidder)
      this.canMintForReward = jsonObject.canMintForReward
      this.currentBid = parseBigNumberOptional(jsonObject.currentBid)
      this.dutchAuctionActive = jsonObject.dutchAuctionActive
      this.dutchAuctionPrice = parseBigNumberOptional(jsonObject.dutchAuctionPrice)
      this.minimumBid = parseBigNumberOptional(jsonObject.minimumBid)
      this.mintNowPrice = parseBigNumberOptional(jsonObject.mintNowPrice)
    }
    return this
  }

  public toJsonObject(): DynamicAuctionJsonObject {
    const result: DynamicAuctionJsonObject = {}
    if (this.bidder) result.bidder = this.bidder.toString()
    if (this.canMintForReward) result.canMintForReward = this.canMintForReward
    if (this.currentBid) result.currentBid = this.currentBid.toString(10)
    if (this.dutchAuctionActive) result.dutchAuctionActive = this.dutchAuctionActive
    if (this.dutchAuctionPrice) result.dutchAuctionPrice = this.dutchAuctionPrice.toString(10)
    if (this.minimumBid) result.minimumBid = this.minimumBid.toString(10)
    if (this.mintNowPrice) result.mintNowPrice = this.mintNowPrice.toString(10)
    return result
  }
}
